<template>
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.44954 16.5288L14.5531 9.62359C17.852 5.16006 19.5015 2.9283 21.0404 3.39991C22.5794 3.87153 22.5794 6.60879 22.5794 12.0833V12.5995C22.5794 14.574 22.5794 15.5613 23.2103 16.1806L23.2437 16.2126C23.8882 16.8188 24.9157 16.8188 26.9707 16.8188C30.6689 16.8188 32.5179 16.8188 33.1428 17.9404C33.1532 17.959 33.1632 17.9777 33.173 17.9966C33.7629 19.1355 32.6923 20.5841 30.5511 23.4812L25.4475 30.3863C22.1485 34.8499 20.499 37.0817 18.9601 36.61C17.4211 36.1384 17.4212 33.4011 17.4212 27.9265L17.4213 27.4106C17.4213 25.436 17.4213 24.4487 16.7904 23.8294L16.757 23.7974C16.1125 23.1912 15.085 23.1912 13.0299 23.1912C9.3318 23.1912 7.48274 23.1912 6.85782 22.0696C6.84747 22.051 6.83741 22.0323 6.82765 22.0134C6.23773 20.8745 7.30833 19.4259 9.44954 16.5288Z"
            stroke="currentColor"
            stroke-width="1.6"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "BoltIcon",
});
</script>
